<template>
    <div>
        <v-autocomplete v-model="estimate.customer" :items="customers" :loading="isLoading" :search-input.sync="search" color="primary" hide-no-data item-text="display"
                        placeholder="Start typing to Search"
                        @change="emitChange"
                        return-object clearable
                        no-filter
        />
        <div v-if="estimate.customer && estimate.customer.name">
            <v-text-field v-model.trim="estimate.customer.name" :rules="requiredRules" label="Name" required disabled/>
            <v-text-field v-model.trim="estimate.customer.email" label="Email"/>
            <v-text-field v-model.trim="estimate.customer.phone" label="Phone"/>
            <v-text-field v-model.trim="estimate.customer.mobile" label="Mobile"/>
            <v-text-field v-model.trim="estimate.customer.make" label="Make"/>
            <v-text-field v-model.trim="estimate.customer.model" label="Model"/>
            <v-text-field v-model.trim="estimate.customer.vrm" label="Registration Mark"/>
            <v-text-field v-model.trim="estimate.customer.colour" label="Colour"/>
        </div>
    </div>
</template>

<script>
    import {EventBus} from '../../../../EventBus';
    import {CustomersHttp} from "../../../../http/customers";
    export default {
        name: "EstimateCustomer",
        data() {
            return {
                search: '',
                customers: [],
                isLoading: false,
                requiredRules: [
                    v => !!v || 'This field is required'
                ],
            }
        },
        props: {
            estimate: {}
        },
        watch: {
            async search (val) {
                // Need more characters to search
                if (val && val.length < 3) return;
                if (val) {
                    this.isLoading = true;
                    await CustomersHttp.findCustomers(val).then(result => {
                        const temp = result.data;
                        temp.map(t => {
                           t.display = `${t.name} - ${t.vrm}`;
                        });
                        this.customers = temp;
                    }).catch(err => {
                        EventBus.$emit('message', {message: err.message, type: 'error'});
                    }).finally(() => this.isLoading = false);
                }
            },
            customer() {
                this.customers = [];
            }
        },
        methods: {
            emitChange() {
                EventBus.$emit('estimate-customer-selected', this.estimate);
            },
            getVal(item) {
                return `${item.name} - ${item.vrm}`
            }
        }
    }
</script>

<style scoped>

</style>
